/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import { useRecoilValue } from 'recoil';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { styled } from 'styled-components';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { authAtom } from '../../states/usuarios/AuthState';
import { GridContainer } from '../../commons/styleds/styleds';
import LinearProgress from '@mui/material/LinearProgress';
import { Box, Tab, Tabs } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useAcoesActions } from '../../states/acao/acao.actions';
import { IAcao } from '../../commons/types/crm';
import { IIdNome } from '../../commons/types/base';
import Breadcrumb from '../../components/Breadcrumb';
import ImgBackground from '../../assets/intoo_E.png';
import Consultor from '../Home/Components/Consultor';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { useVagaContatoActions } from '../../states/vagaContato/vagaContato.actions';
import { useEventosParticipantesActions } from '../../states/eventos/eventosParticipantes.actions';
import dayjs from 'dayjs';
import { useTranslation } from '../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

const isReuniaoType = (idTipo: number, configAcoes: any[]) => {
  const config = configAcoes.find(c => c.id === idTipo);
  return config?.nome?.toLowerCase().includes('reuni');
};

const isIndicacaoType = (idTipo: number, configAcoes: any[]) => {
  const config = configAcoes.find(c => c.id === idTipo);
  return config?.nome?.toLowerCase().includes('indica');
};

const isOutraAcaoType = (idTipo: number, configAcoes: any[]) => {
  const config = configAcoes.find(c => c.id === idTipo);
  return !isReuniaoType(idTipo, configAcoes) && !isIndicacaoType(idTipo, configAcoes);
};

const Acoes: React.FC = () => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const tableRef = useRef();
  const auth = useRecoilValue(authAtom);
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [listTab, setListTab] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const acaoActions = useAcoesActions();
  const vagaContatoActions = useVagaContatoActions();
  const eventosParticipacaoActions = useEventosParticipantesActions();

  const [tabData, setTabData] = useState<{
    eventos: any[];
    acoes: any[];
    configAcoes: IIdNome[];
  }>({
    eventos: [],
    acoes: [],
    configAcoes: [],
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setLoading(true);

    try {
      switch (newValue) {
        case 0:
          setListTab(tabData.acoes.filter((f: any) => isReuniaoType(f.idTipo, tabData.configAcoes)));
          break;
        case 1:
          setListTab(tabData.acoes.filter((f: any) => isIndicacaoType(f.idTipo, tabData.configAcoes)));
          break;
        case 2:
          setListTab(tabData.eventos);
          break;
        case 3:
          setListTab(tabData.acoes.filter((f: any) => isOutraAcaoType(f.idTipo, tabData.configAcoes)));
          break;
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      try {
        const [eventos, acoes, configAcoesData] = await Promise.all([
          eventosParticipacaoActions.list(false, `?IdAssessorado=${auth?.id!}&IncluirEvento=true`),
          acaoActions.list(),
          acaoActions.listConfig()
        ]);

        const formattedEventos = eventos.map((item: any) => ({
          id: item.id!,
          nome: `${translate('evento')} - ${item.evento?.titulo || item.idEventoNavigation?.titulo}`,
          observacoes: `${translate('dataPrevista')}: ${dayjs(item.evento?.dataPrevista || item.idEventoNavigation?.dataPrevista).format('DD/MM/YYYY')}`,
          dtCadastro: item.dtCadastro!,
          anexo: null
        }));

        const filteredAcoes = acoes.filter((a: any) => a.habilitarAssessorado);

        setTabData({
          eventos: formattedEventos,
          acoes: filteredAcoes,
          configAcoes: configAcoesData
        });

        setListTab(filteredAcoes.filter((f: any) => isReuniaoType(f.idTipo, configAcoesData)));
        setLoading(false);
      } catch (error) {
        toast.error(translate('errorCarregarDados'));
        setLoading(false);
      }
    };

    if (auth?.id) {
      loadAllData();
    }
  }, [auth]);

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  const handleCopy = () => {
    const tableElement = tableRef.current as any;
    if (!tableElement) return;

    let clipboardData = '';

    const headers: any[] = [];
    tableElement.querySelectorAll('thead tr th').forEach((th: any) => {
      headers.push(th.textContent);
    });
    clipboardData += headers.join('\t') + '\n';

    tableElement.querySelectorAll('tbody tr').forEach((row: any) => {
      const rowData: any[] = [];
      row.querySelectorAll('td').forEach((td: any) => {
        rowData.push(td.textContent);
      });
      clipboardData += rowData.join('\t') + '\n';
    });

    navigator.clipboard.writeText(clipboardData).then(
      () => {
        alert(translate('tabelaCopiaParaOClipboard'));
      },
    );
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, { html: '#acoes-table' });
    doc.save('acoes.pdf'); //TODO: traduzir ??
  };

  const exportToXLS = () => {
    const tableElement = tableRef.current;
    if (tableElement) {
      const workbook = XLSX.utils.table_to_book(tableElement, { sheet: 'Sheet1' });
      XLSX.writeFile(workbook, 'tabela_exportada.xlsx'); //TODO: traduzir ??
    }
  };

  function renderHtml(htmlString: string) {
    return <span dangerouslySetInnerHTML={{ __html: htmlString }} />;
  }

  function renderWithLinks(text: string) {
    if (!text) return null;

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (!text.match(urlRegex)) {
      return text;
    }

    const result: (string | JSX.Element)[] = [];
    let lastIndex = 0;
    let match;

    const regex = new RegExp(urlRegex);

    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        result.push(text.substring(lastIndex, match.index));
      }

      const url = match[0];
      result.push(
        <a
          key={`url-${match.index}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#0091cf', textDecoration: 'underline' }}
        >
          {url}
        </a>
      );

      lastIndex = regex.lastIndex;
    }

    if (lastIndex < text.length) {
      result.push(text.substring(lastIndex));
    }

    return result;
  }

  return (
    <GridBackground container direction="row" spacing={0}>
      <Consultor />

      <Grid item xs={12}>
        <Breadcrumb />
      </Grid>

      <Grid item xs={12} md={12} sx={{ paddingBottom: '30px' }}>
        <Typography variant="h1">{translate('acoes')}</Typography>
      </Grid>

      <Grid item xs={12} md={12} sx={{ paddingBottom: '10px' }}>
        <TypographyDesc variant="body1">
          {renderHtml(translate('descricaoAcoesAssessoradoHtml'))}
        </TypographyDesc>
      </Grid>

      <Grid item xs={12}>
        <PaperAcoes elevation={2}>
          <Box>
            <Box sx={{ paddingX: '24px' }}>
              <Tabs value={value} onChange={handleChange} aria-label="tabs acoes">
                <Tab label={translate('reunioes')} {...a11yProps(0)} />
                <Tab label={translate('indicacoes')} {...a11yProps(1)} />
                <Tab label={translate('eventos')} {...a11yProps(2)} />
                <Tab label={translate('outrasAcoes')} {...a11yProps(3)} />
              </Tabs>
            </Box>

            {value === 1 && (
              <Grid
                container
                spacing={1}
                sx={{
                  padding: '10px 25px',
                  fontSize: '12px',
                  '& .message-item': {
                    marginTop: 0
                  }
                }}
              >
                {[1, 2, 3].map((num) => {
                  const message = translate(`mensagemIndicacoes${num}`);
                  return message !== `mensagemIndicacoes${num}` && (
                    <Grid
                      key={`mensagem-${num}`}
                      item
                      xs={12}
                      className="message-item"
                    >
                      {message}
                    </Grid>
                  );
                })}
              </Grid>
            )}

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px',
                marginBottom: '20px',
                paddingRight: '24px',
                paddingLeft: '24px',
              }}
            >
              <div>
                <SearchInput
                  variant="outlined"
                  placeholder={translate('buscar')}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div style={{ gap: '12px' }}>
                <ButtonAcao variant="outlined" onClick={handleCopy}>
                  {translate('copiarOConteudo')}
                </ButtonAcao>

                <ButtonAcao variant="outlined" onClick={exportToPDF} sx={{ marginLeft: '12px' }}>
                  <PictureAsPdfOutlinedIcon />
                  {translate('exportarPdf')}
                </ButtonAcao>

                <ButtonAcao variant="outlined" onClick={exportToXLS} sx={{ marginLeft: '12px' }}>
                  <SummarizeOutlinedIcon />
                  {translate('exportarXls')}
                </ButtonAcao>
              </div>
            </div>

            {loading ? <LinearProgress sx={{ width: '100%' }} /> :
              <TabPanel value={0} index={0} dir={theme.direction}>
                <TableContainer component={Paper} ref={tableRef as any}>
                  <Table size="small" aria-label="a dense table" id="acoes-table">
                    <TableHead
                      sx={{
                        minWidth: 650,
                        backgroundColor: 'var(--white-background)',
                        paddingY: '12px',
                      }}
                    >
                      <TableRow>
                        {(value === 0 || value === 1 || value === 3) && (<TableCell>{translate('acao')}</TableCell>)}
                        <TableCell>{translate('observacao')}</TableCell>
                        <TableCell>{translate('data')}</TableCell>
                        <TableCell>{translate('anexo')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listTab.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            minHeight: '72px',
                            height: '72px',
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <TableCell scope="row">
                            {(() => {
                              if (value === 2) {
                                return row.nome;
                              }

                              const configName = tabData.configAcoes.find(
                                (f: any) => f.id === Number(row.idTipo)
                              )?.nome;

                              if (value === 3 && !configName) {
                                return row.nome || `Ação ${row.id}`;
                              }

                              return configName || `Tipo não encontrado: ${row.idTipo}`;
                            })()}
                          </TableCell>
                          <TableCell>{renderWithLinks(row.observacoes)}</TableCell>
                          <TableCell>
                            {row.dtCadastro &&
                              new Date(row.dtCadastro.toString()).toLocaleDateString()}
                          </TableCell>
                          <TableCell>{row.anexo}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
            }
          </Box>
        </PaperAcoes>
      </Grid>
    </GridBackground>
  );
};

export const GridBackground = styled(GridContainer)`
  padding: 40px 32px 80px 32px;
  background-color: var(--gray-background);

  background-image: url(${ImgBackground});
  background-repeat: no-repeat;
  background-position: top right;
  background-attachment: fixed;
`;

export const TypographyDesc = styled(Typography)`
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  max-width: 800px;
`;

const PaperAcoes = styled(Paper)`
  padding-top: 24px;
  border-radius: 12px;
  background-color: #fff;
  width: 100%;
  margin-top: 56px;
`;

const SearchInput = styled(TextField)`
  height: 44px;
  width: 100%;
  max-width: 400px;
  background-color: #fff;
  border-radius: 8px;

  > .MuiInputBase-adornedStart {
    height: 44px;
  }
`;

const ButtonAcao = styled(Button)`
  color: #414651 !important;
  border-color: #d5d7da !important;
  text-transform: none !important;
`;

export default Acoes;
